import {
  CONFIG_PAGES,
  ENTITY_NAMES,
  ICONS_WEB,
  NAV_ITEM_GROUPS,
  PLATFORM_MODULES,
} from "@miplatform/constants";
import {
  FeatureFlagKey,
  IChildNavItemConfig,
  INavItemConfig,
} from "@miplatform/types";
import { MODULES_CONFIG_PATHS } from "./constants/configPaths";
import {
  CONFIG_PATHS,
  CONFIG_ROUTE_ICONS,
  CONFIG_ROUTE_NAMES,
} from "./constants";

const getPageConfigByKey = (key: string) => {
  return {
    name: CONFIG_ROUTE_NAMES[key as keyof typeof CONFIG_ROUTE_NAMES],
    icon: CONFIG_ROUTE_ICONS[key as keyof typeof CONFIG_ROUTE_ICONS],
    path: CONFIG_PATHS[key as keyof typeof CONFIG_PATHS],
  };
};

const getMiDispatchModulePath = (name: string) => {
  return {
    path: MODULES_CONFIG_PATHS[PLATFORM_MODULES.MI_DISPATCH][
      name as keyof (typeof MODULES_CONFIG_PATHS)[typeof PLATFORM_MODULES.MI_DISPATCH]
    ],
    name: CONFIG_ROUTE_NAMES[name as keyof typeof CONFIG_ROUTE_NAMES],
  };
};

const getMiSchedulingModulePath = (name: string) => {
  return {
    path: MODULES_CONFIG_PATHS[PLATFORM_MODULES.MI_SCHEDULING][
      name as keyof (typeof MODULES_CONFIG_PATHS)[typeof PLATFORM_MODULES.MI_SCHEDULING]
    ],
    name: CONFIG_ROUTE_NAMES[name as keyof typeof CONFIG_ROUTE_NAMES],
  };
};

const getMiAccountingModulePath = (name: string) => {
  return {
    path: MODULES_CONFIG_PATHS[PLATFORM_MODULES.MI_ACCOUNTING][
      name as keyof (typeof MODULES_CONFIG_PATHS)[typeof PLATFORM_MODULES.MI_ACCOUNTING]
    ],
    name: CONFIG_ROUTE_NAMES[name as keyof typeof CONFIG_ROUTE_NAMES],
  };
};

const getMiInspectionsModulePath = (name: string) => {
  return {
    path: MODULES_CONFIG_PATHS[PLATFORM_MODULES.MI_INSPECTIONS][
      name as keyof (typeof MODULES_CONFIG_PATHS)[typeof PLATFORM_MODULES.MI_INSPECTIONS]
    ],
    name: CONFIG_ROUTE_NAMES[name as keyof typeof CONFIG_ROUTE_NAMES],
  };
};

const getMiEstimatingModulePath = (name: string) => {
  return {
    path: MODULES_CONFIG_PATHS[PLATFORM_MODULES.MI_ESTIMATING][
      name as keyof (typeof MODULES_CONFIG_PATHS)[typeof PLATFORM_MODULES.MI_ESTIMATING]
    ],
    name: CONFIG_ROUTE_NAMES[name as keyof typeof CONFIG_ROUTE_NAMES],
  };
};

export const configChildNavItems: Record<string, IChildNavItemConfig[]> = {
  [CONFIG_PAGES.MI_DISPATCH]: [
    {
      ...getMiDispatchModulePath(CONFIG_PAGES.USERS),
      testId: "nav-midispatch-users",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.HR],
    },
    {
      ...getMiDispatchModulePath(CONFIG_PAGES.ROLES_HR),
      testId: "nav-midispatch-roles-hr",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.HR],
      name: "Work Permissions",
    },
    {
      ...getMiDispatchModulePath(CONFIG_PAGES.ORDER_CALENDARS),
      testId: "nav-midispatch-order-calendars",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.CALENDARS],
      name: "Order Calendars",
    },
    {
      ...getMiDispatchModulePath(CONFIG_PAGES.LABOR_RATES),
      testId: "nav-midispatch-labor-rates",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.PRICING],
    },
    {
      ...getMiDispatchModulePath(CONFIG_PAGES.MIDAY_SETTINGS),
      testId: "nav-midispatch-miday-settings",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.MIDAY],
    },
    {
      ...getMiDispatchModulePath(CONFIG_PAGES.CANNOT_PERFORM_REASONS),
      testId: "nav-midispatch-cannot-perform-reasons",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.MIDAY],
    },
  ],
  [CONFIG_PAGES.MI_SCHEDULING]: [
    {
      ...getMiSchedulingModulePath(CONFIG_PAGES.USERS),
      testId: "nav-mischeduling-users",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.HR],
    },
    {
      ...getMiSchedulingModulePath(CONFIG_PAGES.ORDER_CALENDARS),
      testId: "nav-mischeduling-order-calendars",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.CALENDARS],
      name: "Order Calendars",
    },
    {
      ...getMiSchedulingModulePath(CONFIG_PAGES.WORK_ORDER_CALENDARS),
      testId: "nav-mischeduling-work-order-calendars",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.CALENDARS],
      name: "Work Order Calendars",
      featureFlagKey: FeatureFlagKey.AdvancedWorkOrdersEnabled,
    },
    {
      ...getMiSchedulingModulePath(CONFIG_PAGES.ROLES_HR),
      testId: "nav-mischeduling-roles-hr",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.HR],
      name: "Work Permissions",
    },
    {
      ...getMiSchedulingModulePath(CONFIG_PAGES.WORK_ORDER_TEMPLATES),
      testId: "nav-mischeduling-work-order-templates",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.PRODUCTION],
    },
    {
      ...getMiSchedulingModulePath(CONFIG_PAGES.WORK_ORDER_STEPS),
      testId: "nav-mischeduling-work-order-steps",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.PRODUCTION],
    },
  ],
  [CONFIG_PAGES.MI_ACCOUNTING]: [
    {
      ...getMiAccountingModulePath(CONFIG_PAGES.USERS),
      testId: "nav-miaccounting-users",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.HR],
    },
    {
      ...getMiAccountingModulePath(CONFIG_PAGES.WORK_ORDER_TEMPLATES),
      testId: "nav-miaccounting-work-order-templates",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.PRODUCTION],
    },
    {
      ...getMiAccountingModulePath(CONFIG_PAGES.WORK_ORDER_STEPS),
      testId: "nav-miaccounting-work-order-steps",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.PRODUCTION],
    },
    {
      ...getMiAccountingModulePath(CONFIG_PAGES.QUICKBOOKS_INTEGRATION),
      testId: "nav-miaccounting-quickbooks-integration",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.QUICKBOOKS],
    },
    {
      ...getMiAccountingModulePath(CONFIG_PAGES.QUICKBOOKS_IMPORT_CUSTOMERS),
      testId: "nav-miaccounting-quickbooks-import-customers",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.QUICKBOOKS],
    },
    {
      ...getMiAccountingModulePath(CONFIG_PAGES.ROLES_HR),
      testId: "nav-miaccounting-roles-hr",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.HR],
      name: "Work Permissions",
    },
  ],
  [CONFIG_PAGES.MI_INSPECTIONS]: [
    {
      ...getMiInspectionsModulePath(CONFIG_PAGES.USERS),
      testId: "nav-miinspections-users",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.HR],
    },
    {
      ...getMiInspectionsModulePath(CONFIG_PAGES.INSPECTION_CALENDARS),
      testId: "nav-miinspections-inspection-calendars",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.CALENDARS],
      name: "Inspection Calendars",
    },
    {
      ...getMiInspectionsModulePath(CONFIG_PAGES.ROLES_HR),
      testId: "nav-miinspections-roles-hr",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.HR],
      name: "Work Permissions",
    },
    {
      ...getMiInspectionsModulePath(CONFIG_PAGES.INSPECTION_TEMPLATES),
      testId: "nav-miinspections-inspection-templates",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.PRODUCTION],
      name: ENTITY_NAMES.INSPECTION_TEMPLATES,
    },
  ],
  [CONFIG_PAGES.MI_ESTIMATING]: [
    {
      ...getMiEstimatingModulePath(CONFIG_PAGES.USERS),
      testId: "nav-miestimating-users",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.HR],
    },
    {
      ...getMiEstimatingModulePath(CONFIG_PAGES.ROLES_HR),
      testId: "nav-miestimating-roles-hr",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.HR],
      name: "Work Permissions",
    },
  ],
  [CONFIG_PAGES.HR]: [
    {
      ...getPageConfigByKey(CONFIG_PAGES.DEPARTMENTS),
      testId: "nav-hr-departments",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.HR],
    },
    {
      ...getPageConfigByKey(CONFIG_PAGES.USERS),
      testId: "nav-hr-users",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.HR],
    },
    {
      ...getPageConfigByKey(CONFIG_PAGES.ROLES_HR),
      testId: "nav-hr-roles",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.HR],
    },
    {
      ...getPageConfigByKey(CONFIG_PAGES.HOLIDAYS),
      testId: "nav-hr-holidays",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.HR],
    },
  ],
  [CONFIG_PAGES.OPERATIONS]: [
    {
      ...getPageConfigByKey(CONFIG_PAGES.ORDER_TEMPLATES),
      testId: "nav-order-templates",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.OPERATIONS],
    },
    {
      ...getPageConfigByKey(CONFIG_PAGES.ROLES_OPERATIONS),
      testId: "nav-operations-roles",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.OPERATIONS],
    },
    {
      ...getPageConfigByKey(CONFIG_PAGES.RECORDABLES),
      testId: "nav-recordables",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.OPERATIONS],
    },
    {
      ...getPageConfigByKey(CONFIG_PAGES.WARRANTY_ITEMS),
      testId: "nav-warranty-items",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.OPERATIONS],
    },
    {
      ...getPageConfigByKey(CONFIG_PAGES.CAMERA_LINES),
      testId: "nav-camera-lines",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.OPERATIONS],
    },
    {
      ...getPageConfigByKey(CONFIG_PAGES.DOCUMENT_TYPES),
      testId: "nav-document-types",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.OPERATIONS],
    },
    {
      ...getPageConfigByKey(CONFIG_PAGES.INSPECTION_AUTHORITIES),
      testId: "nav-inspection-authorities",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.MISC],
    },
    {
      ...getPageConfigByKey(CONFIG_PAGES.CITIES),
      testId: "nav-cities",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.MISC],
    },
  ],
  [CONFIG_PAGES.AUTO]: [
    {
      ...getPageConfigByKey(CONFIG_PAGES.ORDER_AUTO_TRIGGER),
      testId: "nav-order-auto-trigger",
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.AUTO],
    },
    {
      ...getPageConfigByKey(CONFIG_PAGES.WORK_ORDER_AUTO_TRIGGER),
      testId: "nav-work-order-auto-trigger",
      featureFlagKey: FeatureFlagKey.AdvancedWorkOrdersEnabled,
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.AUTO],
    },
    {
      ...getPageConfigByKey(CONFIG_PAGES.AUTO_BUILD),
      testId: "nav-auto-build",
      featureFlagKey: FeatureFlagKey.AdvancedWorkOrdersEnabled,
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.AUTO],
    },
    {
      ...getPageConfigByKey(CONFIG_PAGES.AUTO_ASSIGN),
      testId: "nav-auto-assign",
      featureFlagKey: FeatureFlagKey.AdvancedWorkOrdersEnabled,
      group: CONFIG_ROUTE_NAMES[CONFIG_PAGES.AUTO],
    },
  ],
};

export const configNavItems: INavItemConfig[] = [
  {
    ...getPageConfigByKey(CONFIG_PAGES.MI_DISPATCH),
    testId: "nav-mi-dispatch",
    group: NAV_ITEM_GROUPS.MODULES,
    items: configChildNavItems[CONFIG_PAGES.MI_DISPATCH],
  },
  {
    ...getPageConfigByKey(CONFIG_PAGES.MI_SCHEDULING),
    testId: "nav-mi-scheduling",
    group: NAV_ITEM_GROUPS.MODULES,
    items: configChildNavItems[CONFIG_PAGES.MI_SCHEDULING],
  },
  {
    ...getPageConfigByKey(CONFIG_PAGES.MI_ACCOUNTING),
    testId: "nav-mi-accounting",
    group: NAV_ITEM_GROUPS.MODULES,
    items: configChildNavItems[CONFIG_PAGES.MI_ACCOUNTING],
  },
  {
    ...getPageConfigByKey(CONFIG_PAGES.MI_INSPECTIONS),
    testId: "nav-mi-inspections",
    group: NAV_ITEM_GROUPS.MODULES,
    items: configChildNavItems[CONFIG_PAGES.MI_INSPECTIONS],
  },
  {
    ...getPageConfigByKey(CONFIG_PAGES.MI_ESTIMATING),
    testId: "nav-mi-estimating",
    group: NAV_ITEM_GROUPS.MODULES,
    items: configChildNavItems[CONFIG_PAGES.MI_ESTIMATING],
  },
  {
    ...getPageConfigByKey(CONFIG_PAGES.HR),
    testId: "nav-hr",
    group: NAV_ITEM_GROUPS.GENERAL,
    items: configChildNavItems[CONFIG_PAGES.HR],
  },
  {
    ...getPageConfigByKey(CONFIG_PAGES.OPERATIONS),
    testId: "nav-operations",
    group: NAV_ITEM_GROUPS.GENERAL,
    items: configChildNavItems[CONFIG_PAGES.OPERATIONS],
  },
  {
    ...getPageConfigByKey(CONFIG_PAGES.AUTO),
    testId: "nav-auto",
    group: NAV_ITEM_GROUPS.GENERAL,
    items: configChildNavItems[CONFIG_PAGES.AUTO],
  },
  {
    ...getPageConfigByKey(CONFIG_PAGES.SETTINGS),
    testId: "nav-settings",
    group: NAV_ITEM_GROUPS.GENERAL,
  },
  {
    name: "MiBuild",
    icon: ICONS_WEB.HOME,
    path: "/",
    testId: "nav-item-go-back-to-mibuild",
    group: NAV_ITEM_GROUPS.SETTINGS,
  },
];
